/* eslint-disable react/prop-types */
import React, { useState } from "react";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { AccountingVouchersService } from "services/accounting-vouchers";

function ActionCell({ item, setDataTable }) {
  const [open, setOpen] = useState(false);
  const normalizedStatus = String(item?.status || "DRAFT").toUpperCase();
  const isDraft = normalizedStatus === "DRAFT";
  const isPosted = normalizedStatus === "POSTED";
  const isReversed = normalizedStatus === "REVERSED";

  const handleOpenDelete = () => {
    if (isDraft) {
      setOpen(true);
      return;
    }

    if (isPosted) {
      toast.error("Chứng từ đã ghi sổ không được xóa. Hãy dùng chức năng Đảo chứng từ.");
      return;
    }

    if (isReversed) {
      toast.error("Chứng từ đã đảo không được xóa để đảm bảo vết kiểm toán.");
      return;
    }

    toast.error("Không thể xóa chứng từ ở trạng thái hiện tại.");
  };

  const handleDelete = async () => {
    try {
      await AccountingVouchersService.delete(item._id);
      setDataTable((prev) => ({
        ...prev,
        rows: prev.rows.filter((row) => row.id !== item._id),
      }));
      setOpen(false);
      toast.success("Xóa chứng từ ghi sổ thành công");
    } catch (error) {
      toast.error(error?.response?.data?.message || "Xóa chứng từ ghi sổ thất bại");
      setOpen(false);
    }
  };

  return (
    <SoftBox display="flex" alignItems="center">
      <Link to={`/templates/accounting-vouchers/${item._id}/view`}>
        <SoftTypography variant="body1" color="success" sx={{ cursor: "pointer", lineHeight: 0 }}>
          <Tooltip title="Xem chi tiết" placement="top">
            <Icon>visibility</Icon>
          </Tooltip>
        </SoftTypography>
      </Link>
      <SoftBox mx={2}>
        <Link to={`/templates/accounting-vouchers/${item._id}/edit`}>
          <SoftTypography variant="body1" color="info" sx={{ cursor: "pointer", lineHeight: 0 }}>
            <Tooltip
              title={isDraft ? "Cập nhật" : "Chứng từ đã ghi sổ/đã đảo bị khóa cập nhật"}
              placement="top"
            >
              <Icon>edit</Icon>
            </Tooltip>
          </SoftTypography>
        </Link>
      </SoftBox>
      <SoftTypography
        onClick={handleOpenDelete}
        variant="body1"
        color={isDraft ? "error" : "secondary"}
        sx={{ cursor: "pointer", lineHeight: 0, opacity: isDraft ? 1 : 0.65 }}
      >
        <Tooltip
          title={
            isDraft
              ? "Xóa"
              : isPosted
                ? "CTGS đã ghi sổ không được xóa, hãy đảo chứng từ"
                : "CTGS đã đảo không được xóa"
          }
          placement="left"
        >
          <Icon>delete</Icon>
        </Tooltip>
      </SoftTypography>
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>Xác nhận xóa</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Bạn có chắc chắn muốn xóa chứng từ ghi sổ nháp này không? Sau khi xóa, chứng từ sẽ không còn xuất hiện trên danh sách và cũng không thể là nguồn dữ liệu cho các sổ tự sinh liên quan.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Hủy</Button>
          <Button onClick={handleDelete} autoFocus color="error">
            Đồng ý
          </Button>
        </DialogActions>
      </Dialog>
    </SoftBox>
  );
}

export default ActionCell;
